import "./CreateProjectDialogComponent.scss";

interface CreateProjectDialogComponentProps {
    isCreating?: boolean;
    creationStep?: string;
}

const CreateProjectDialogComponent = (props: CreateProjectDialogComponentProps) => {
    const { isCreating = false, creationStep = "creating project" } = props;

    return (
        <div className="w-full create-project-dialog">
            <div className="text-center">
                <h2 className="text-2xl font-semibold mb-4">
                    Creating Your Project
                </h2>
                <p className="text-muted-foreground mb-6">
                    We're setting up your application with smooth animations and standard functionalities.
                </p>
                
                {isCreating && (
                    <div className="space-y-4">
                        <div className="flex justify-center">
                            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
                        </div>
                        <p className="text-sm text-muted-foreground capitalize">
                            {creationStep}...
                        </p>
                    </div>
                )}
                
            </div>
        </div>
    );
};

export default CreateProjectDialogComponent;
